import { parse } from 'date-fns';
import { z } from 'zod';

export const inRequestSchema = z.object({
  status: z.object({
    value: z.string(),
    label: z.string(),
  }),
  document: z.object({
    value: z.string(),
    label: z.string(),
  }),
  reason: z.object({
    value: z.string(),
    label: z.string(),
  }),
  reasonFields: z.record(z.string()),
  dateForApproval: z
    .string()
    .transform((v) => parse(v, 'yyyy-MM-dd', new Date()).toISOString()),
  observation: z.string().min(1, { message: 'Obrigatório' }),
});

export const schema = inRequestSchema
  .extend({
    hasUploadedFile: z.boolean().default(false),
    file: z
      .instanceof(File)
      .or(z.never().nullish())
      .transform((value) => value ?? undefined),
    justification: z.string().min(1, { message: 'Obrigatório' }),
  })
  .refine(
    ({ file, hasUploadedFile }) => {
      if (!file && !hasUploadedFile) return false;

      return true;
    },
    {
      message: 'É necessário enviar um arquivo',
      path: ['file'],
    },
  );

export type TenantDocumentRequestDetailsFormSchema =
  | z.infer<typeof schema>
  | z.infer<typeof inRequestSchema>;
